import { gql } from "@apollo/client";

export const ADD_NOTIFICATION_GQL = gql`
	mutation addNotificationAppDashboard ($message: String!) {
		addNotification(message: $message) {
			id
			message
		}
	}
`;

export const ADD_PATCH_UPDATE_NOTIFICATION_GQL = gql`
	mutation addPatchUpdateNotificationAppDashboard ($changelog: String!) {
		addPatchUpdateNotification(changelog: $changelog) {
			id
			changelog
		}
	}
`;

export const GET_ALL_KF_REPORTS_GQL = gql`
	query getAllKnightFrankReportsAppDashboard {
		getAllKnightFrankReports {
			id
			year
			quarter
		}
	}
`;
